<template>
  <van-tabs animated @change="onChangeTab" class="products-regular" sticky offset-top="46">
    <van-tab v-for="(val, ind) in tabbars" :title="val.name" :key="ind">
      <div class="the-top">
        <van-list class="tian-deail list" v-model="val.loading" :immediate-check="false" :finished="val.finished" :finished-text="val.finishedText" :error.sync="val.error" error-text="请求失败，点击重新加载" @load="getMoreProduct">
          <div v-for="item in val.product_list" :key="item.id" class="tian-deail">
            <div class="tian-item" @click.stop.prevent="onToDetail(item)">
              <div class="tian-item-main" :class="{
                  'sold-out': item.isFull || item.serverTime >= item.endTime
                }">
                <div class="product-information">
                  <!-- title -->
                  <div class="title">
                    <span>{{ item.name }}</span>
                    <van-tag class="points" v-if="item.scoreRate > 0">返积分</van-tag>
                    <img v-if="
                        (item.productLevel === 1 || item.productLevel === 2) &&
                        item.serverTime <= item.endTime
                      " class="hot-tag" src="../../../assets/img/hot.png" alt />
                  </div>
                  <!-- tag -->
                  <div class="tag">
                    <van-tag v-if="item.label1" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label1 }}</van-tag>
                    <van-tag v-if="item.label2" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label2 }}</van-tag>
                    <van-tag v-if="item.attachLabel" plain color="#ff9900">{{
                      item.attachLabel
                    }}</van-tag>
                  </div>
                  <!-- data -->
                  <div class="data">
                    <!-- gain -->
                    <div class="gain">
                      <template v-if="item.ifStair">
                        <b>{{ rateInterval(item).minRate }}</b>
                        <span>%</span>
                        <span class="fuhao">~</span>
                        <b>{{ rateInterval(item).maxRate }}</b>
                        <span>%</span>
                      </template>
                      <template v-else>
                        <b>{{ expectedRate(item) }}</b>
                        <span>%</span>
                        <template v-if="item.greenhandRate && item.greenhandRate > 0">
                          <span class="fuhao">+</span>
                          <b>{{ item.greenhandRate }}</b>
                          <span>%</span>
                        </template>
                      </template>
                      <!-- text -->
                      <div class="txt">预期年化收益率</div>
                    </div>
                    <!-- term -->
                    <div class="term">
                      <div class="term-box">
                        <!-- day -->
                        <div class="day">
                          <span class="s1">{{ item.investDuration }}</span>
                          <span class="s2">天</span>
                        </div>
                        <!-- text -->
                        <div class="txt">
                          <!-- {{ item.miniAmount / 1000000 }}万元起投 -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- progress -->
                  <div class="progress">
                    <div class="progress-box">
                      <!-- progress-style -->
                      <div class="progress-style">
                        <div v-if="item.isFull || item.serverTime >= item.endTime" class="progress-pivot" style="width: 100%"></div>
                        <div v-else class="progress-pivot" :style="{ width: item.sold + '%' }"></div>
                      </div>
                      <!-- result -->
                      <div class="result">{{ progressText(item) }}</div>
                    </div>
                  </div>

                  <!-- 标签 -->
                  <div class="aside" color="#fc6524" size="large" v-if="
                      item.saleLabel === '1' && item.isFull <= item.endTime
                    ">
                    新手专享
                  </div>

                  <div :class="_isOnlyShowShuang11Icon() ? 'label-img' : 'aside'" color="#fc6524" size="large" v-if="
                      (item.saleLabel === '2' || item.productLevel === 1) &&
                      item.serverTime <= item.endTime
                    ">
                    <img v-if="_isOnlyShowShuang11Icon()" style="width: 35px" class="hot-tag" src="../../../assets/img/common/shuang11-rate.jpg" alt />
                    <span v-else>{{ item.hotRate ? "热销加息" : "人气产品" }}</span>
                  </div>
                  <div class="aside" color="#fc6524" size="large" v-if="
                      item.saleLabel === '4' && item.serverTime <= item.endTime
                    ">
                    秒杀
                  </div>
                  <div class="aside" v-if="
                      item.productLevel === 2 && item.serverTime <= item.endTime
                    ">
                    加息
                  </div>
                  <div v-if="item.serverTime >= item.endTime" class="signet-sold-out">
                    已结束
                  </div>
                  <div v-if="item.isFull" class="signet-sold-out">已售罄</div>

                  <!-- <img
                    v-if="item.isFull || item.serverTime >= item.endTime"
                    class="signet-sold-out"
                    src="../../../assets/img/invest/signet-sold-out.png"
                    alt
                  /> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 无数据，显示空 -->
          <van-empty description="暂无产品" v-if="val.product_list.length == 0"></van-empty>
        </van-list>
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
import * as ProductApi from "@/api/product"
import { Tab, Tabs, Toast, Dialog, Tag, List, Empty } from "vant"

export default {
  name: "TianProductsRegular",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [List.name]: List,
    [Empty.name]: Empty
  },

  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      finishedText: "",
      currentIndex: 0,
      pageSize: 10,
      activeName: "全部产品",
      tabbars: [
        {
          name: "全部产品",
          tag: "all",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        },
        {
          name: "3个月内",
          tag: "three",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        },
        {
          name: "3-6个月",
          tag: "six",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        },
        {
          name: "6个月以上",
          tag: "twelve",
          pageNo: 1,
          product_list: [],
          loading: false,
          finished: false,
          error: false,
          finishedText: ""
        }
      ]
    }
  },

  created() {
    this.onChangeTab(0)
  },

  methods: {
    isSoldOut(n) {
      return n.isFull || n.serverTime >= n.endTime
    },
    // 利率
    rateInterval: function (n) {
      // console.info(n)
      if (n.ifStair) {
        let stairRate = n.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > n.stairRate["rate" + k]) {
              minRate = n.stairRate["rate" + k]
            }
            if (maxRate < n.stairRate["rate" + k]) {
              maxRate = n.stairRate["rate" + k]
            }
          }
        })
        if (n.hasNewYearActivity && n.activityDiscount) {
          //有新年红包活动
          return {
            minRate: parseFloat(minRate + n.activityDiscount.rate).toFixed(2),
            maxRate: parseFloat(maxRate + n.activityDiscount.rate).toFixed(2)
          }
        } else {
          return { minRate: minRate, maxRate: maxRate }
        }
      }
    },
    expectedRate: function (n) {
      if (n.hasNewYearActivity && n.activityDiscount) {
        //保留小数点后两位的过滤器，尾数四舍五入
        return parseFloat(n.expectedRate + n.activityDiscount.rate).toFixed(2)
      } else {
        return n.expectedRate
      }
    },
    onChangeTab(index) {
      this.currentIndex = index
      if (this.tabbars[index].product_list.length < 1) {
        this.getMoreProduct()
      }
    },

    getMoreProduct() {
      let current = this.tabbars[this.currentIndex]
      current.loading = true

      let index = this.currentIndex
      let investDuration = this.tabbars[index].tag
      let pageNo = this.tabbars[index].pageNo
      let productType = 1

      let pageSize = 10
      let the = this
      let timeout = 1000
      // 每次加载不超过15个产品，下拉加载更多
      ProductApi.list({
        investDuration,
        pageNo,
        pageSize,
        productType
      })
        .then((data) => {
          current.product_list = current.product_list.concat(data.list)

          if (current.pageSize === 0 && data.list.length === 0) {
            current.finishedText = "暂无产品"
          } else if (data.list.length < the.pageSize) {
            // current.finishedText = "已经到底了";
            current.finished = true
          }

          current.pageNo++
          current.loading = false
          // console.log(data.list)
        })
        .catch((e) => {
          current.loading = false
          current.error = true
          Toast(e.msg || e.message)
        })
    },

    onToDetail(product) {
      this.$router.push({ path: "/detail", query: { productId: product.id } })
    },
    progressText: function (item) {
      if (item.isFull || item.serverTime >= item.endTime) {
        return "100%"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.the-top {
  padding-bottom: 52px;
}

// @import url('../idx.less');
// ::v-deep .van-tab {
//   color: #999;
// }

::v-deep .van-hairline--top-bottom:after {
  border: none;
}

::v-deep .van-tab {
  color: #999;
}

::v-deep .van-tab--active {
  color: #333;
  font-weight: 700;
}

::v-deep .van-tag--large {
  font-size: 12px;
  padding-left: 25px;
}

.tian-item-main {
  margin: 10px 13px;
  &.sold-out {
    filter: grayscale(0%) opacity(0.6);
  }
}

.product-information {
  position: relative;
  padding: 14px 12px;
  border-radius: 5px;
  background-color: #fff;

  // name
  .title {
    font-size: 16px;
    height: 1.5em;
    overflow: hidden;
    color: #333333;
    word-break: break-all;
    .points {
      margin-left: 5px;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fc6524;
    }
    .hot-tag {
      width: 20px;
      margin-left: 15px;
    }
  }
  // tag
  .tag {
    //  margin-left: -6px;
    .van-hairline--surround::after {
      border: none;
    }
    .van-tag {
      font-size: 10px;
      margin-right: 3px;
    }
    .hide {
      display: none;
    }
    div {
      display: inline-block;
      height: 8px;
      width: 0.8px;
      background-color: #ff9900;
    }
  }
  // data
  .data {
    display: flex;
    align-items: center;
    // text
    .txt {
      color: #999;
      font-size: 14px;
    }
    // gain
    .gain {
      flex: 1;
      b {
        font-size: 36px;
        color: #fc6524;
        font-weight: normal;
      }
      span {
        font-size: 15px;
        color: #fc6524;
        margin-left: 1px;
      }
      .fuhao {
        font-size: 18px;
        color: #fc6524;
        margin: auto 5px;
      }
    }
    // term
    .term {
      flex: 1;
      text-align: center;

      .term-box {
        height: 72px;
        padding-right: 40px;
        // day
        .day {
          height: 53px;
          line-height: 53px;
          color: #666;

          .s1 {
            font-size: 22px;
          }
          .s2 {
            font-size: 18px;
            margin-left: 2px;
          }
        }
      }
    }
  }
  // progress
  .progress {
    margin-top: 10px;
    .progress-box {
      display: flex;
      align-items: center;
      // title
      .title {
        font-size: 11px;
        color: #666;
        margin-top: 3px;
      }
      // progress-style
      .progress-style {
        width: 250px;
        height: 7px;
        line-height: 16px;
        position: relative;
        background-color: #e9e9e9;
        border-radius: 7px;
        overflow: hidden;
        .progress-pivot {
          box-sizing: border-box;
          height: 100%;
          background-color: #fc6524;
          border-radius: 7px;
        }
      }
      // result
      .result {
        font-size: 14px;
        margin-left: 10px;
        color: #666;
      }
    }
  }
  .aside,
  .signet-sold-out {
    position: absolute;
    top: 15px;
    right: 0px;
    padding: 0 12px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 25px 0 0 25px;
    color: #fff;
  }
  .signet-sold-out {
    background-color: #d6d6d7;
  }
  // aside
  .aside {
    background-color: rgb(252, 101, 36);
  }
  .label-img {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 0;
  }
}
</style>
